import { Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@/shared/components/ProtectedRoute';
import { GuideLifecycleGate } from '@/features/auth/components/GuideLifecycleGate';
import { GuideLifecycleLayout } from '@/layouts/GuideLifecycleLayout';
import { GuideApplicationStatusPage } from '@/features/guide-profile/pages/GuideApplicationStatusPage';
import { GuideProfileSetupPage } from '@/features/guide-profile/pages/GuideProfileSetupPage';

/**
 * Authenticated guide-lifecycle screens.
 *
 * These sit outside `AppLayout` so the traveler-surface gate cannot bounce an
 * applicant before their own page renders. Each page defers to the shared
 * resolver for anything it should not be showing.
 */
export const guideLifecycleRoutes = {
  element: (
    <ProtectedRoute requireGuideProfile>
      <GuideLifecycleGate>
        <GuideLifecycleLayout />
      </GuideLifecycleGate>
    </ProtectedRoute>
  ),
  children: [
    { path: '/guide-application/status', element: <GuideApplicationStatusPage /> },
    { path: '/guide-profile/setup', element: <GuideProfileSetupPage /> },

    // Legacy URLs. Anyone landing here is sent through the resolver rather
    // than seeing a dead page or the retired wizard.
    {
      path: '/onboarding',
      element: <Navigate to="/guide-profile/setup" replace />,
    },
    {
      path: '/submission-success',
      element: <Navigate to="/guide-application/status" replace />,
    },
  ],
};
